import { Link } from 'react-router-dom'
import { useAuth } from '../auth'
import { Topbar } from '../components/Topbar'
import { StatusLight } from '../components/StatusLight'
import { EmptyState } from '../components/EmptyState'
import { Button } from '../components/Button'

export function HomePage() {
  const { user, features } = useAuth()

  const isEmpty = features.length === 0

  return (
    <div className="page">
      <Topbar />
      <main className="page-main">
        {isEmpty ? (
          <EmptyState
            mark="workbench"
            title="No plugins visible yet"
            body={
              user?.isOwner
                ? 'No features are enabled. Open Admin → Features to enable one and assign it to yourself or another user.'
                : 'Ask the Owner to enable a feature and assign it to you in Admin → Features.'
            }
            cta={
              user?.isOwner ? (
                <Link to="/admin/features">
                  <Button variant="primary">Open Admin → Features</Button>
                </Link>
              ) : null
            }
          />
        ) : (
          <div className="home-grid">
            {features.map((f) => (
              <Link key={f.id} to={`/plugin/${f.pluginId}`} className="card">
                <span className="card-light" aria-hidden="true">
                  <StatusLight state="on" />
                </span>
                <div className="card-icon" aria-hidden="true">
                  {f.icon}
                </div>
                <div className="card-id">{f.pluginId}</div>
                <div className="card-name">{f.name}</div>
                <div className="card-desc">{f.description}</div>
                <div className="card-spacer" />
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  )
}
